
























































































































import Vue from 'vue';
import firstCharsToUpperCase from '@/util/firstCharsToUpperCase.js';
import ReporteGenerico from '../reporte/ReporteGenerico.vue';
export default Vue.extend({
  components: {
    ReporteGenerico,
  },
  props: {
    recibosInit: Array,
    disabled: Boolean,
  },
  data: () => ({
    edoCtaDialog: false,
    precision: 2,
    unidad: {},
    menu1: false,
    menu2: false,
    dateInicial: '',
    dateFinal: '',
    formatoFecha: 'DD/MM/YYYY',
    request: {
      end: '',
      start: '',
    },
    headers: [],
    reporteDTO: {},
  }),
  mounted() {
    this.fechas();
  },
  computed: {
    computedDateIFormatted() {
      return this.$moment(this.dateInicial).format(this.formatoFecha);
    },
    computedDateFFormatted() {
      return this.fechaFinal().format(this.formatoFecha);
    },
  },
  methods: {
    fechas() {
      this.dateInicial = this.$moment().startOf('month').format();
      this.dateFinal = this.$moment().endOf('month').format();
    },
    fechaFinal() {
      return this.$moment(this.dateFinal).add(1, 'months').startOf('month').subtract(1);
    },
    generarCuenta() {
      const admin = this.$store.getters.getAdmin;
      const condo = this.$store.getters.getCondo;
      const unidad = this.unidad;
      this.request.start = this.$moment(this.dateInicial);
      this.request.end = this.fechaFinal();
      const req = this.request;
      const datos = {admin, condo, unidad, req};
      const cuentas2 = this.$store.dispatch('getEstadoCta2', datos).then((result) => {
        console.log('getEstadoCta2 result', result);
        this.reporteDTO = result.data;
      }).catch((e) => {
        console.error('generarCuenta error: ', e);
        this.$toast.error(e);
      });
    },
    dateFormat(fecha) {
      return firstCharsToUpperCase(this.$moment(fecha).format('MMMM YYYY'));
    },
    closeDialog() {
      this.$emit('reload', {}),
      this.edoCtaDialog = false;
      this.headers = [];
      this.reporteDTO = {};
      this.fechas();
    },
    print() {
      window.print();
    },
  },
  watch: {
    edoCtaDialog() {
      if (this.edoCtaDialog) {
        this.unidad = Object.assign({}, this.recibosInit[0]);
        console.debug('UNIDAD: %o', this.unidad);
      }
    },
  },
});
